module.exports = __webpack_public_path__ + "static/media/Snow-PNG-Transparent-Image.8219a8cb.png";